import { render, staticRenderFns } from "./tableIndex.vue?vue&type=template&id=518af390&scoped=true&"
import script from "./tableIndex.vue?vue&type=script&lang=js&"
export * from "./tableIndex.vue?vue&type=script&lang=js&"
import style0 from "./tableIndex.vue?vue&type=style&index=0&id=518af390&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518af390",
  null
  
)

export default component.exports